//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import * as loglevel from 'loglevel'

interface OtLogger extends loglevel.Logger {
  FOCUS: (message: string, ...args: any[]) => void
  STDOUT: (message: string, ...args: any[]) => void
  BANNER: (message: string, ...args: any[]) => void
  ErrorLevel: () => void
  DebugLevel: () => void
  InfoLevel: () => void
  WarnLevel: () => void
}

export const logOT: OtLogger = loglevel.getLogger('OpenTradeLogger') as OtLogger

if (process.env.stage) {
  logOT.setLevel(loglevel.levels.DEBUG)
} else {
  logOT.setLevel(loglevel.levels.INFO)
}

;(logOT as any).FOCUS = (message: string, ...args: any[]) => {
  logOT.warn('FOCUS:' + message, ...args, ':ENDFOCUS')
}
;(logOT as any).STDOUT = (message: string, ...args: any[]) => {
  logOT.warn('STDOUT:' + message, ...args, ':ENDSTDOUT')
}
;(logOT as any).BANNER = (message: string, ...args: any[]) => {
  logOT.warn(
    'STDOUT:--------------------------------' + message,
    ...args,
    '-------------------------------- :ENDSTDOUT'
  )
}
;(logOT as any).ErrorLevel = () => {
  logOT.setLevel(loglevel.levels.ERROR)
}
;(logOT as any).DebugLevel = () => {
  logOT.setLevel(loglevel.levels.DEBUG)
}
;(logOT as any).InfoLevel = () => {
  logOT.setLevel(loglevel.levels.INFO)
}
;(logOT as any).WarnLevel = () => {
  logOT.setLevel(loglevel.levels.INFO)
}
